/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { Card } from './styles';

interface AiManagementCollapsibleCardProps {
  title: string;
  aside?: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}

const AiManagementCollapsibleCard: React.FC<AiManagementCollapsibleCardProps> = ({
  title,
  aside,
  defaultOpen = true,
  className = '',
  bodyClassName = 'px-4 py-4',
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Card className={`border overflow-hidden ${className}`}>
      <button
        type="button"
        className="collapsible-header btn btn-block d-flex align-items-center justify-content-between text-left rounded-0 border-0 px-4 py-3 m-0"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
      >
        <span className="collapsible-title font-weight-bold">{title}</span>
        <span className="d-flex align-items-center ml-auto">
          {aside}
          <i className="material-icons ml-2">{open ? 'expand_less' : 'expand_more'}</i>
        </span>
      </button>
      <Collapse in={open}>
        <div>
          <div className={`border-top ${bodyClassName}`}>{children}</div>
        </div>
      </Collapse>
    </Card>
  );
};

export default AiManagementCollapsibleCard;
